<script>
    export default {
        name: '',
        props: {
            data: {
                required: false,
                default: () => ({})
            }
        },
        data () {
            return {};
        },
        methods: {},
        components: {},
        mounted () {
        }
    };
</script>

<template>
   <div class="swiper-item swiper-slide">
       <a :href="data.url" :title="data.short_title">
           <img class="swiper-item "
                :key="data.id"
                :src="data.covers[1]"
                :alt="data.short_title">
       </a>
   </div>
</template>

<style lang="less" scoped>
    .swiper-item{
        width: 100%;
        .px2rem(height, 150);
        margin-bottom: 0.4rem;
    }
</style>
